import { useMutation } from "react-query"
import api from "../client"
import { OrderDocsPayload, OrderDocsResponseData } from "../types/order"

const postData = async (payload: OrderDocsPayload) => {
    const { data } = await api.post<OrderDocsResponseData>(
        "/orders/docs",
        payload
    )

    return data
}

export const useOrderDocuments = () => {
    return useMutation((payload: OrderDocsPayload) => {
        return postData(payload)
    })
}
